<template>
  <div class="productAiEmployees">
    <div class="banner">
      <div class="h3">
        <div class="bannerLamination">
          <img src="../../../assets/img/p_sz_1.svg" alt="" />
        </div>
        <img src="../../../assets/img/p_sz_2.png" />
      </div>
    </div>
    <!-- 产品概述 -->
    <div class="content-block product-overView">
      <div
        class="title-wrap"
        ref="titleWarp_1"
        data-name="titleWarp_1"
        :class="{ fadeIn: animationControl.titleWarp_1 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_23.png" />
        </div>
        <div class="title">产品概述</div>
      </div>
      <div class="content">
        <div
          class="slogan-wrap"
          :class="{ fadeIn: animationControl.titleWarp_1 }"
        >
          <div class="slogan1">「数智员工」—— AI驱动的多场景办公增效引擎</div>
          <div class="l-center">
            <div class="slogan2">
              专为企业打造的智能工作平台，深度融合人工智能相关技术，重构自动化、智能化办公全链路
            </div>
          </div>
        </div>
        <div class="img1">
          <img src="../../../assets/img/p_sz_3.svg" />
        </div>
        <div class="slogan-wrap-2 l-center">
          <div class="slogan-3">
            将员工从大量高重复、机械化、程序化的工作中解放出来，为企业增效、降本
          </div>
        </div>
      </div>
    </div>
    <!-- 产品定位 -->
    <div class="content-block product-position">
      <div
        class="title-wrap"
        ref="titleWarp_2"
        data-name="titleWarp_2"
        :class="{ fadeIn: animationControl.titleWarp_2 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_4.png" />
        </div>
        <div class="title">产品定位</div>
      </div>
      <div class="content">
        <div
          class="slogan-wrap l-center"
          :class="{ fadeIn: animationControl.titleWarp_2 }"
        >
          <div class="slogan-1">替代90%+的重复劳动，让团队专注高价值工作！</div>
        </div>
        <div class="img1">
          <img src="../../../assets/img/p_sz_5.svg" />
        </div>
      </div>
    </div>
    <!-- 产品特点 -->
    <div class="content-block product-features">
      <div
        class="title-wrap"
        ref="titleWarp_3"
        data-name="titleWarp_3"
        :class="{ fadeIn: animationControl.titleWarp_3 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_24.png" />
        </div>
        <div class="title">产品特点</div>
      </div>
      <div class="content">
        <div
          class="slogan-wrap"
          :class="{ fadeIn: animationControl.titleWarp_3 }"
        >
          <div class="slogan-1">完美员工，拿钱少、没情绪、干的好！</div>
        </div>
        <div class="l-center" style="margin-top: 100px">
          <div class="block-wrap">
            <featureBlock
              v-for="(feature, index) in featureList"
              :key="index"
              :info="feature"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 技术支撑 -->
    <div class="content-block product-techSupport">
      <div
        class="title-wrap"
        ref="titleWarp_4"
        data-name="titleWarp_4"
        :class="{ fadeIn: animationControl.titleWarp_4 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_12.png" />
        </div>
        <div class="title">技术支撑</div>
      </div>
      <div class="content l-center">
        <div style="width: 1100px">
          <div class="tabs">
            <div
              v-for="(item, index) in techSupportList"
              :key="index"
              class="tab"
              :class="{ active: curTechSupportTabIndex === index }"
              @click="handleTechSupportTabChange(index)"
            >
              <div class="tab-title">{{ item.title }}</div>
            </div>
          </div>
          <div class="swiper-container" ref="techSupportSwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, idx) in techSupportList"
                :key="idx"
              >
                <techSupportBlock :info="item" style="width: 1100px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="content-block product-advantage">
      <div
        class="title-wrap"
        ref="titleWarp_5"
        data-name="titleWarp_5"
        :class="{ fadeIn: animationControl.titleWarp_5 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_25.png" />
        </div>
        <div class="title">产品优势</div>
      </div>
      <div class="content l-center">
        <div class="block-wrap">
          <productAdvantageBlock
            v-for="(item, index) in productAdvantageList"
            :key="index"
            :info="item"
          />
        </div>
      </div>
    </div>
    <!-- 财务场景 -->
    <div class="content-block product-financeScene">
      <div
        class="title-wrap"
        ref="titleWarp_6"
        data-name="titleWarp_6"
        :class="{ fadeIn: animationControl.titleWarp_6 }"
      >
        <div>
          <img src="../../../assets/img/p_sz_22.png" />
        </div>
        <div class="title">财务场景</div>
      </div>
      <div class="content">
        <img src="../../../assets/img/p_sz_21.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import featureBlock from "./components/featureBlock.vue";
import techSupportBlock from "./components/techSupportBlock.vue";
import productAdvantageBlock from "./components/productAdvantageBlock.vue";
import Swiper, { Autoplay } from "swiper";
Swiper.use([Autoplay]);
import "swiper/swiper-bundle.css";

export default {
  name: "productAiEmployees",
  components: {
    featureBlock,
    techSupportBlock,
    productAdvantageBlock,
  },
  data() {
    return {
      //产品特点
      featureList: [
        {
          title: "跨系统",
          subTitle: "不依赖API，想接就接",
          description:
            "支持非侵入、全自动式的跨系统多源数据采集与解析、处理与报送",
          background: "linear-gradient( 180deg, #E0ECFD 0%, #E2EAFF 100%)",
          icon: require("../../../assets/img/p_sz_7.svg"),
          themColor: "#6D9EE6",
        },
        {
          title: "安全性",
          subTitle: "私域管理，安全可信",
          description: "本地化部署、数据不出域，确保系统、数据的安全性",
          background: "linear-gradient( 180deg, #E7E6FC 0%, #CCC3F7 100%)",
          icon: require("../../../assets/img/p_sz_8.svg"),
          themColor: "#8C7EDD",
        },
        {
          title: "便捷性",
          subTitle: "你说我做，简单直接",
          description:
            "对接企业私有微信，问答交互+自动触发为业务处理带来便捷性",
          background: "linear-gradient( 180deg, #FCF3F2 0%, #FFE2D3 100%)",
          icon: require("../../../assets/img/p_sz_9.svg"),
          themColor: "#FF8947",
        },
        {
          title: "全天候",
          subTitle: "7*24小时，全年无休",
          description: "低维护成本、高准确性的7*24小时全天候不间断工作",
          background: " linear-gradient( 180deg, #C8F0F2 0%, #98DCD4 100%)",
          icon: require("../../../assets/img/p_sz_10.svg"),
          themColor: "#49817D",
        },
      ],
      //技术支撑
      techSupportList: [
        {
          id: 1,
          title: "语义理解引擎",
          subTitle: "理解指令，精准执行",
          description:
            "基于深度学习的场景化语义模型，可识别问答交互中的关键信息（如：开发票），与业务应用精准关联",
          icon: require("../../../assets/img/p_sz_13.svg"),
        },
        {
          id: 2,
          title: "多模态数据解析",
          subTitle: "图片、文档、音频等，全支持",
          description:
            "整合OCR、NLP等技术，实现非结构化数据的自动化提取与分类，准确率达99%+",
          icon: require("../../../assets/img/p_sz_14.svg"),
          iconStyle: {
            top: "0px",
          },
        },
        {
          id: 3,
          title: "工作过程模拟仿真",
          subTitle: "按需配置，快速实施",
          description:
            "自研控件可快速记录用户页面操作过程，并自动生成该工作过程的模拟执行脚本",
          icon: require("../../../assets/img/p_sz_15.svg"),
          iconStyle: {
            top: "10px",
          },
        },
        {
          id: 4,
          title: "流程自动化引擎",
          subTitle: "自主运行，无人值守",
          description:
            "基于预设规则库，快速串联实际工作项，自动执行各类业务应用的标准化流程",
          icon: require("../../../assets/img/p_sz_16.svg"),
        },
        {
          id: 5,
          title: "实时预警机制",
          subTitle: "异常可知，风险可控",
          description:
            "基于风险规则库实时扫描业务数据异常，构建事前预警、事中拦截、事后追溯的全周期智能风控体系",
          icon: require("../../../assets/img/p_sz_17.svg"),
        },
      ],
      //产品优势
      productAdvantageList: [
        {
          title: "多场景",
          subTitle: "场景不限，持续拓展",
          description:
            "可支持财务、人力、营销、法务、招投标等多种业务的典型场景",
          icon: require("../../../assets/img/p_sz_18.png"),
        },
        {
          title: "可定制",
          subTitle: "个性需求，亦能满足",
          description: "可按企业需求定制应用，平均5-10个工作日即可上线",
          icon: require("../../../assets/img/p_sz_19.png"),
        },
        {
          title: "低成本",
          subTitle: "收费透明，一劳永逸",
          description: "一次性采购+年服务费，单应用年投入不足人工的1/20",
          icon: require("../../../assets/img/p_sz_20.png"),
        },
      ],
      //当前技术支撑
      curTechSupportTabIndex: 0,
      //动画观察者
      animationObserver: null,
      //animationControl
      animationControl: {
        titleWarp_1: false,
        titleWarp_2: false,
        titleWarp_3: false,
        titleWarp_4: false,
        titleWarp_5: false,
        titleWarp_6: false,
      },
      swiper: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.initAnimationObserver();
      });
      this.initSwiper();
    },
    initAnimationObserver() {
      const {
        titleWarp_1,
        titleWarp_2,
        titleWarp_3,
        titleWarp_4,
        titleWarp_5,
        titleWarp_6,
      } = this.$refs;
      this.animationObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.animationControl[entry.target.dataset.name] =
              entry.isIntersecting;
          });
        },
        { threshold: 0.5 }
      );
      this.animationObserver.observe(titleWarp_1);
      this.animationObserver.observe(titleWarp_2);
      this.animationObserver.observe(titleWarp_3);
      this.animationObserver.observe(titleWarp_4);
      this.animationObserver.observe(titleWarp_5);
      this.animationObserver.observe(titleWarp_6);
    },
    initSwiper() {
      this.swiper = new Swiper(this.$refs.techSupportSwiper, {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        on: {
          slideChange: () => {
            this.$nextTick(() => {
              this.curTechSupportTabIndex = this.swiper.realIndex;
            });
          },
        },
      });
    },
    handleTechSupportTabChange(index) {
      this.curTechSupportTabIndex = index;
      this.swiper.slideToLoop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.productAiEmployees {
  font-family: MicrosoftYaHei;
  color: #414b59;
}
.banner {
  width: 100%;
  height: 433px;
  background: url(../../../assets/img/p_sz_1.png) no-repeat center center;
  background-size: 1920px 433px;
  position: relative;

  .h3 {
    position: relative;
    top: 130px;
    width: 1180px;
    margin: 0 auto;
    .bannerLamination {
      position: absolute;
      right: -60px;
      top: -50px;
    }
  }
}
.title-wrap {
  opacity: 0;
  .title {
    height: 37px;
    font-size: 28px;
    margin-top: -23px;
  }
}
.fadeIn {
  animation: fade-in 0.5s ease-in forwards;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}

.content-block {
  min-height: 300px;
  padding: 70px 0;
  padding-bottom: 50px;
  text-align: center;
}
// 产品概述
.product-overView {
  .content {
    .slogan-wrap {
      .slogan1 {
        margin-top: 34px;
        font-size: 36px;
        color: #414b59;
        font-weight: bold;
      }
      .slogan2 {
        margin-top: 25px;
        width: 512px;
        height: 52px;
        font-size: 16px;
        color: #909399;
      }
    }
    .slogan-wrap-2 {
      margin-top: 20px;
      .slogan-3 {
        background: #ffffff;
        border-radius: 27px;
        border: 1px solid #d0def0;
        padding: 10px 20px;
      }
    }
    .img1 {
      margin-top: -35px;
    }
  }
}
// 产品定位
.product-position {
  height: 669px;
  background: linear-gradient(
    127deg,
    #eef9ff 0%,
    #eff6ff 26%,
    #f6f9ff 51%,
    #f6f7ff 74%,
    #fffbf5 100%
  );
  .content {
    .slogan-wrap {
      margin-top: 34px;
      .slogan-1 {
        width: 450px;
        font-size: 27px;
        font-weight: bold;
        //渐变文字
        background: linear-gradient(90deg, #007aff 0%, #00eaff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .img1 {
      margin-top: -100px;
    }
  }
}
// 产品特点
.product-features {
  height: 690px;
  .content {
    .slogan-wrap {
      .slogan-1 {
        margin-top: 34px;
        font-size: 36px;
        color: #414b59;
        font-weight: bold;
      }
    }
    .block-wrap {
      width: 1100px;
      display: flex;
      justify-content: space-between;
    }
  }
}
// 技术支撑
.product-techSupport {
  height: 600px;
  background: url(../../../assets/img/p_sz_11.png) no-repeat center center;
  background-size: cover;
  .content {
    margin-top: 30px;
    .tabs {
      display: flex;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 0px 30px 0px rgba(11, 24, 67, 0.1);
      margin-bottom: 20px;
      .tab {
        cursor: pointer;
        // transition: all 0.2s;
        flex: 1;
        padding: 18px;
        &.active {
          background-color: #5a91f4;
          color: #fff;
        }
      }
      .tab-title {
        font-size: 18px;
      }
    }
  }
}
// 产品优势
.product-advantage {
  .content {
    margin-top: 60px;
    .block-wrap {
      width: 1100px;
      display: flex;
      justify-content: space-between;
    }
  }
}
// 财务场景
.product-financeScene {
  height: 660px;
  overflow: hidden;
  background: url(../../../assets/img/p_sz_11.png) no-repeat center center;
  background-size: cover;
  .content {
    margin-top: -89px;
  }
}
.swiper-container {
  width: 1100px;
  height: 300px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0px 0px 30px 0px rgba(11, 24, 67, 0.1);
}
</style>
